<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable">Username</label>
          <div class="p-col">
            <InputText :disabled="mode == 'edit'" maxlength="50" id="email" type="text" class=""
              v-model="obj_data.email" placeholder="Input" @input="removeSpaces('email')" />
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable">Fullname</label>
          <div class="p-col">
            <InputText maxlength="50" id="name" type="text" class="" v-model="obj_data.fullname" placeholder="Input" />
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable">Email</label>
          <div class="p-col">
            <InputText maxlength="50" id="email_info" type="text" class="" v-model="obj_data.email_info"
              placeholder="mail@example.com" @input="removeSpaces('email_info')" />
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable">Phone number</label>
          <div class="p-col">
            <InputText maxlength="15" id="phone" type="text" class="" v-model="obj_data.phone" placeholder="Input"
              @input="removeSpaces('phone')" />
          </div>
        </div>



        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable">Avatar</label>
          <div class="p-col">
            <div class="cus-text">Recommend: 500x500px Maximum:10 MB</div>
            <div class="cus-text">Accepted file:JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component" accept="image/*" name="images[]" id="images_service" type="file"
              @change="onFileSelectFile" /><!--@change="onFileSelectLogo"-->
            <input class="input_tmp_validator" id="list_file">
            <div class="cus-text style_list_image">
              <div class="box-image" v-for="(item, index) in list_file" :key="index">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="onFileClear(item, index)"><img
                    src="/assets/images/icon/cancel_black_24dp.png" /></div>
              </div>
              <!--              <span :key="comFilename">{{ obj_data.filename }}</span>-->
            </div>

            <!--            <div class="select-button" style="background-color: rgb(227, 237, 252);height: max-content;text-align: justify;justify-items: center;display: flex;padding: 0.55rem;margin: -0.429rem;">
              <span style="margin: auto;">Tải lên</span>
            </div>-->
          </div>
        </div>

        <div class="p-card-field" style="margin-top: 8px;margin-bottom: 8px">
          <label class="p-col-fixed txt-right style_line_password " v-if="mode == 'edit'">- Input new password if you
            want to change.</label>
          <label class="p-col-fixed txt-right style_line_password " v-if="mode == 'edit'">- Password must be between 6
            and 50 characters. Please choose a strong password.</label>
          <label class="p-col-fixed txt-right style_line_password " v-if="mode != 'edit'">Password must be between 6 and
            50 characters. Please choose a strong password.</label>
          <!--          <div class="p-col">
                    </div>-->
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable" :class="mode != 'edit' ? 'txt-required':''">
            <span v-if="mode == 'edit'">New password</span>
            <span v-else>Password</span>
          </label>
          <div class="p-col">
            <div class="box-password-style">
              <InputText maxlength="50" id="password" :type="passwordType" class="" v-model="obj_data.password"
                placeholder="Input" />
              <!--              <i  v-if="passwordType === 'text'" class="material-icons lg-icon-password" @click="switchVisibility">visibility</i>
                            <i  v-else class="material-icons lg-icon-password" @click="switchVisibility">visibility_off</i>-->
            </div>
          </div>
        </div>
        <div class="p-card-field" v-if="mode != 'edit'">
          <label class="p-col-fixed txt-right txt_style_lable" :class="mode != 'edit' ? 'txt-required':''">Confirm
            password</label>
          <div class="p-col">
            <div class="box-password-style">
              <InputText maxlength="50" id="Re_enter_password" :type="passwordReType" class=""
                v-model="obj_data.re_password" placeholder="Input" />
              <!--              <i  v-if="passwordReType === 'text'" class="material-icons lg-icon-password" @click="switchVisibility($event,'re')">visibility</i>
                            <i  v-else class="material-icons lg-icon-password" @click="switchVisibility($event,'re')">visibility_off</i>-->
            </div>
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable">Note</label>
          <div class="p-col">
            <Textarea id="note" maxLength="500" rows="2" cols="30" :autoResize="true" v-model="obj_data.note"
              placeholder="Input" />
            <!--            <InputText id="note" type="text" class="" v-model="obj_data.note"  placeholder="Input"/>-->
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable">Type</label>
          <div class="p-col">
            <div class="gender-options">
              <label>
                <div class="p-field-radiobutton">
                  <RadioButton name="gender" value="admin_child" v-model="obj_data.role" />Administartor
                </div>
              </label>
              <label>
                <div class="p-field-radiobutton">
                  <RadioButton name="gender" value="care" v-model="obj_data.role" />Saleperson
                </div>
              </label>
            </div>
          </div>
        </div>
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.is_chat_unassigned" :binary="true" />
            <label class="p-col-fixed txt-right text">It’s possible to see chats with unassigned customers</label>
          </div>
        </div>
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>


      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>


    <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
      Are you want to delete this family ?
      <template #footer>

        <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
        <Button label="Confirm" @click="deleteData()" icon="pi pi-check"
          class="p-button-danger  btn-confirm-delete-dialog" />
      </template>
    </Dialog>
    <CustomCropper
      :key="keyCropper"
      v-if="showCropper"
      :image-src="imageSrc"
      @cropped-image="handleCroppedImage"
      @close="showCropper = false"
    />
  </form>
</template>
<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
//import Common from "../../../core/Common";
export default {
  components: {
  },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      showCropper: false,
      keyCropper: 0,
      imageSrc: null,
      listStatus: [
        {id: true, name: 'Active', style: 'color:  #000000;',disabled: false},
        {id: false, name: 'Banned',style: 'color:  #000000;',disabled: false},
        //{id: 3, name: 'Deleted',style: 'color:  #000000;',disabled: true}
      ],

      listUser: [],
      listUserAll: [],

      key_state:0,

      listCountry: [],
      listCountryAll: [],
      mapCountryAll:{},

      listState: [],
      listStateAll: [],

      showDeleteDialog:false,

      list_id_file_delete :[],

      passwordType: 'password',
      passwordReType: 'password',

      file_product :null,
      list_file_product :[],
      list_id_file_delete_product :[],
      dataFamilyDisplay:false,
      componentDataFamily:1,
      dataFamily:{
      },
      dataModelUserFamily:null,
      componentKeyUserFamily:1,
      listDataUserFamily:[],


      dataModelProperty:null,
      componentKeyProperty:1,
      listDataProperty:[],

      obj_data:{
        filename:"",
        prefix_phone:"",
      },
      comFilename:1,
      list_phone_code: [
        {
          prefix_phone:"+84",
        },
        {
          prefix_phone:"+45",
        }
      ],
      dataBookingRound: [],
      selProperty: null,
      listProperty: [],
      listPropertyAll: [],
      listDocsCate: [],
      listDocsCateAll: [],
      from_to: null,
      address: null,
      start_booking_date: null,
      end_booking_date: null,
      partArr: [],
      time_zone_local : moment.tz.guess(true),
      componentKey: 0,
      list_file :[],
      maxFileSize: 2097152*50 , //100MB  2MB   /*104857600, // 100MB*/
    }
  },
  watch: {
    /* async "selProperty"() {
       if (!this.$commonFuction.isEmpty(this.selProperty)) {
         this.address = this.selProperty?.address;
         this.partArr = this.selProperty?.part;
         if (this.mode == 'add') {
           var arr = [];
           this.partArr.map(m => {
             arr.push({ord: m.order_booking, id: m.id});
           })
           arr.map(m=> {
             var tmp = [];
             for (let i =0; i < arr.length; i++) {
               let a = m.ord - i + arr.length;
               if (a > arr.length) {
                 a = a - arr.length;
               }
               tmp.push({ordinal: a, part_id: m.id, round: (i+1)});
             }
             this.dataBookingRound.push(tmp);
           })
         }
         this.componentKey++;
       }
     },
     "start_booking_date"() {
       if (this.partArr.length) {
         let days = 14 * this.partArr.length;
         this.end_booking_date = moment.tz(this.start_booking_date, this.time_zone_local).add(days, 'days').format("LL");
       }
     }*/
  },
  async mounted() {
    /*await this.getListProperty();
    await this.getListDocsCate();*/
    console.log("this.model:",this.model)
    //this.getListCountry();
    //this.getListUser();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.model;
      this.obj_data.filename = this.model?.item_avatar?.file_name ?? ''
      if (!this.$commonFuction.isEmpty(this.model?.item_avatar)) {
        let url = this.model?.item_avatar?.url
        let obj = {'name': this.obj_data.filename, 'file': '', 'objectURL': url, type: 'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
        this.list_file.push(obj)
      }
      this.obj_data.email_info =  this.model?.email ?? ''
      /*if (!this.$commonFuction.isEmpty(this.model.country_id)){
        this.getListState(this.model.country_id);
      }
      var user_customer_care = this.model.user_customer_care
      if (user_customer_care.length > 0){
        if (!this.$commonFuction.isEmpty(user_customer_care[0]["user_customer_care"])){
          if (!this.$commonFuction.isEmpty(user_customer_care[0]["user_customer_care"]["sale_person_id"])){
            this.obj_data.sale_person_id =  user_customer_care[0]["user_customer_care"]["sale_person_id"]
          }
        }
      }
      if (!this.$commonFuction.isEmpty(this.model.birthday)){
        this.obj_data.birthday =new Date(this.model.birthday);
        console.log("this.obj_data.birthday:",this.obj_data.birthday)
      }*/


      /*if (!this.$commonFuction.isEmpty(this.obj_data.available_from)) {
        this.obj_data.available_from = moment.tz(this.obj_data.available_from, this.time_zone_local).format("LL");
      }
      if (!this.$commonFuction.isEmpty(this.obj_data.available_to)) {
        this.obj_data.available_to = moment.tz(this.obj_data.available_to, this.time_zone_local).format("LL");
      }*/
      /*
            var where_key_part = {
              admin_property_list: {uid: {_eq: this.model.id}},
              deleted: {_eq: false}
            }
            var data_list_part = await this.$CoreService.getListUserPropertyPart(where_key_part);
            var list_part = this.$commonFuction.convertJsonObject(data_list_part.list)

            var list_convert = [];
            var stt = 0;
            for (let lp = 0; lp < list_part.length; lp++) {
              stt++;
              var itemDataLP = list_part[lp]
              var name_txt = itemDataLP?.name ?? null
              var part = itemDataLP?.part ?? [];
              var part_txt = "";
              for (let k = 0; k < part.length; k++) {
                var itemDataP = part[k];
                var uid_ = itemDataP?.uid
                if (uid_ == this.model.id){
                  if (!Common.isEmpty(part_txt)){
                    part_txt +=' ,';
                  }
                  part_txt +=itemDataP?.order_booking ?? '';
                }
              }
              itemDataLP.part_txt = part_txt;
              itemDataLP.name_txt = name_txt;
              itemDataLP.stt = stt;
              list_convert.push(itemDataLP)
            }

            var where_key = {
              type : {_eq : 2},
              uid : {_eq : this.model.id},
              // booking: {id: {_is_null: true} },
            }
            var data_list_family = await this.$CoreService.getListPeople(where_key);
            var list_family = this.$commonFuction.convertJsonObject(data_list_family.list)
            console.log("list_familylist_family:",list_family)
            var list_family_convert = [];
            for (let g = 0; g < list_family.length; g++) {
              var itemDataProduct = list_family[g];
              var list_file = itemDataProduct?.list_file ?? [];
              var list_convert_file = [];
              console.log("list_filelist_file:",list_file)
              for (let jj = 0; jj < list_file.length; jj++) {
                var itemFile = list_file[jj]
                itemFile["objectURL"] = itemFile?.url ?? null;
                itemFile["type"] = 'old_edit';
                list_convert_file.push(itemFile)
              }
              if (!this.$commonFuction.isEmpty(itemDataProduct.phone) && !this.$commonFuction.isEmpty(itemDataProduct.prefix_phone)) {
                itemDataProduct.phone_txt = itemDataProduct.prefix_phone+itemDataProduct.phone
              }

              itemDataProduct["list_file_product"] = list_convert_file;
              itemDataProduct["image_list"] = list_convert_file;
              console.log("itemDataProduct:",itemDataProduct)
              list_family_convert.push(itemDataProduct)
            }
            console.log("list_family_convertlist_family_convert:",list_family_convert)
            this.listDataProperty = list_convert;
            this.dataModelProperty = DataServices.getModel('property_user');
            this.componentKeyProperty++;

            this.listDataUserFamily = list_family_convert;
            this.loadTableUserFamily()*/
      /* this.dataModelUserFamily = DataServices.getModel('user_family');
       this.componentKeyUserFamily++;*/

      this.componentKey++;
    }else {
      //thêm mới
      this.obj_data = {
        /* fullname: "Tuyen",
         email: "asdasdaskdjkask@gmail.com",
         prefix_phone: "+45",
         phone: "234434535",*/
        /*
        password: "123456",
        re_password: "123456",*/

        //default data

        role: this.$constants.ROLE_ACCOUNT.ADMIN_CHILD,
        active: true,
        ordinal: 1,
      };
      this.dataModelUserFamily = DataServices.getModel('user_family');
      this.componentKeyUserFamily++;

      this.componentKey++;
    }
  },
  methods: {
    handleCroppedImage(itemFile) {
       this.list_file=[];
       this.list_file.push(itemFile)
    },
    removeSpaces(type) {
      // Loại bỏ tất cả khoảng cách
      if (type == 'phone'){
        this.obj_data.phone = this.obj_data.phone.replace(/\s+/g, '');
      }else if (type == 'email'){
        // chặn thêm kí tự đặt biệt và có dấu tiếng Việt và cả dấu @ nữa nhé
        this.obj_data.email = this.obj_data.email.replace(/[^a-zA-Z0-9._-]/g, '');

        // this.obj_data.email = this.obj_data.email.replace(/[^a-zA-Z0-9@._-]/g, '');
      }else if (type == 'email_info'){
        this.obj_data.email_info = this.obj_data.email_info.replace(/\s+/g, '');
      }
    },
    async getListUser(){
      var where_key = {
        deleted : {_eq : false},
        role : {_eq : this.$constants.ROLE_ACCOUNT.CARE},
        // booking: {id: {_is_null: true} },
      }
      var list = await this.$CoreService.getListUser(where_key);
      this.listUser =list.list;
      this.listUserAll = list.list;
    },
    async SearchUser(search, loading){
      console.log(loading);
      if(search !== '' && search !== null){
        var where_key = {
          deleted : {_eq : false},
          role : {_eq : this.$constants.ROLE_ACCOUNT.CARE},
        };
        if (!this.$commonFuction.isEmpty(search)){
          where_key.fullname = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListUser(where_key);
        this.listUser = list.list;
        //console.log("this.listProperty:",this.listProperty)
      }else{
        // cosnole.log("dasdasd")
        this.listUser = this.listUserAll
      }
    },

    async changeState() {
      this.key_state++;
    },
    async changeCountry() {
      this.obj_data.state_id =null;
      this.getListState(this.obj_data.country_id);
      //  this.key_form++;
      this.key_state++;
    },
    async getListCountry(){
      var where_key = {
        deleted : {_eq : false},
        // booking: {id: {_is_null: true} },
      }
      var list = await this.$CoreService.getListCountry(where_key);
      this.listCountry =list.list;
      this.listCountryAll = list.list;
      this.mapCountryAll = list.map_list;
    },
    async SearchCountry(search, loading){
      console.log(loading);
      if(search !== '' && search !== null){
        var where_key = {
          deleted : {_eq : false},
        };
        if (!this.$commonFuction.isEmpty(search)){
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListCountry(where_key);
        this.listCountry = list.list;
        //console.log("this.listProperty:",this.listProperty)
      }else{
        // cosnole.log("dasdasd")
        this.listCountry = this.listCountryAll
      }
    },
    async getListState(country_id =null){
      var where_key = {
        deleted : {_eq : false},
        // booking: {id: {_is_null: true} },
      }
      if (!this.$commonFuction.isEmpty(country_id)){
        where_key["country_id"] =  {_eq : country_id}
      }
      var list = await this.$CoreService.getListState(where_key);
      this.listState =list.list;
      this.listStateAll = list.list;
    },
    async SearchState(search, loading){
      console.log(loading);
      if(search !== '' && search !== null){
        var where_key = {
          deleted : {_eq : false},
        };
        if (!this.$commonFuction.isEmpty(this.model.country_id)){
          where_key["country_id"] =  {_eq : this.model.country_id}
        }
        if (!this.$commonFuction.isEmpty(search)){
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListState(where_key);
        this.listState = list.list;
        //console.log("this.listProperty:",this.listProperty)
      }else{
        // cosnole.log("dasdasd")
        this.listState = this.listStateAll
      }
    },
    switchVisibility(event,type=null) {
      console.log("event:",event)
      console.log("typetype:",type)
      if (type=='re'){
        this.passwordReType = this.passwordReType === 'password' ? 'text' : 'password'
      }else {
        this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
      }
    },
    async deleteData() {
      this.showDeleteDialog = false;
      var list_data = []
      for (let i = 0; i < this.listDataUserFamily.length; i++) {
        var item_data = this.listDataUserFamily[i];
        if (this.deleteId != item_data.id) {
          list_data.push(item_data);
        }
      }
      this.listDataUserFamily = list_data;
      this.loadTableUserFamily()
    },
    async loadTableUserFamily() {
      var stt = 0;
      var listDataUserFamily = this.listDataUserFamily;
      //this.mapServicePriceProduct = {};
      for (let i = 0; i < listDataUserFamily.length; i++) {
        stt++;
        //var itemData = listDataUserFamily[i];
        //var id = itemData?.id ?? null;
        listDataUserFamily[i].stt = stt;
        listDataUserFamily[i].index = i;
        // this.mapServicePriceProduct[id] = itemData;
      }
      this.listDataUserFamily = listDataUserFamily
      // console.log(" this.listDataUserFamily:", this.listDataUserFamily)
      this.dataModelUserFamily = DataServices.getModel('user_family');
      //this.dataModelProduct.processData(listDataUserFamily)
      this.componentKeyUserFamily++;
    },
    async validateDataUserFamily() {
      if (this.$commonFuction.isEmpty(this.dataFamily.name)) {
        alert('Please enter Fullname');
        return true;
      }
      if (!this.$commonFuction.isEmpty(this.dataFamily.prefix_phone) || !this.$commonFuction.isEmpty(this.dataFamily.phone) ) {
        if (this.$commonFuction.isEmpty(this.dataFamily.prefix_phone) || this.$commonFuction.isEmpty(this.dataFamily.phone)){
          alert('Please enter Phone number');
          return true;
        }
      }
      if (!this.$commonFuction.isEmpty(this.dataFamily.email)) {
        if( !(await this.$commonFuction.IsEmail(this.dataFamily.email)) ){
          alert("Email is not in correct format!");
          return true;
        }
      }

      if (this.list_file_product.length >0){
        if (this.list_file_product.length != 2){
          alert("Please choose 2 photos!");
          return true;
        }
      }
    },
    async saveDataUserFamily() {
      var that = this;
      if (await this.validateDataUserFamily()) {
        return
      }
      this.$commonFuction.is_loading(true);
      //console.log("this.from_to", this.from_to);
      //console.log("partArr", this.dataBookingRound);
      var params = this.dataFamily
      //delete this.dataFamilyDisplay
      console.log("paramsparams:",params)
      var id = params?.id ?? null;
      var itemObject = {
        // stt:1,
        list_id_file_delete_product:this.list_id_file_delete_product,
        //avatar:this.list_file_product[0].objectURL,
        list_file_product:this.list_file_product,
        image_list:this.list_file_product,
        name:params?.name ?? null,
        email:params?.email ?? null,
        personal_id:params?.personal_id ?? null,
        relationship:params?.relationship ?? null,
        phone:params?.phone ?? null,
        prefix_phone:params?.prefix_phone ?? null,
        phone_txt:null,
      }
      if (!this.$commonFuction.isEmpty(params.phone) && !this.$commonFuction.isEmpty(params.prefix_phone)) {
        itemObject.phone_txt = params.prefix_phone+params.phone
      }

      if (!this.$commonFuction.isEmpty(id)) {
        itemObject["id"] = id;
        this.listDataUserFamily[params?.index] = itemObject;
      }else {
        itemObject["id"] = moment().valueOf()+"";
        itemObject["is_new"] =1;//sp này do thêm mới chứ ko từ edit dat trong db
        this.listDataUserFamily.push(itemObject)
      }
      console.log("itemObjectitemObject:",itemObject)


      this.loadTableUserFamily()

      setTimeout(function () {
        //Gọi API refeshtoken
        that.dataFamilyDisplay=false;
        that.$commonFuction.is_loading(false);
        that.clearSaveUserFamily();
      }, 1000);

      /*params["list_file"] = this.list_file
      params["list_type"] = this.listDataUserFamily
      params["list_madatory"] = this.listDataMadatory
      params["list_lang"] = this.listLang
      params["list_id_file_delete"] = this.list_id_file_delete
      console.log('saveData', params)
      this.$emit('save', params)*/
    },
    clearSaveUserFamily() {
      this.dataFamily.id = null;
      this.dataFamily.name = '';
      this.dataFamily.relationship = '';
      this.dataFamily.prefix_phone = '';
      this.dataFamily.phone = '';
      this.dataFamily.email = '';
      this.dataFamily.personal_id = '';
      this.list_file_product = [];
      this.list_id_file_delete_product = [];
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      console.log("action.nameaction.name:",action.name)
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          //console.log("datadatadata:",data)
          /*this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111"+pageTransaction,payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }*//*
          this.index_edit =data.data.index
          this.obj_data.type_id =data.data.id
          this.obj_data.price_select =data.data.price_key
          this.key_type_id++;

          this.dataFamilyDisplay = true*/
          console.log("data.datadata.data:",data.data)

          this.list_file_product = data.data?.list_file_product ?? []
          this.list_id_file_delete_product = data.data?.list_id_file_delete_product ?? []
          /*if (this.list_file_product.length > 0){
            delete data.data.list_file_product;
            delete data.data.image_list;
          }
          console.log("data.datadata.data11:",data.data)
          this.dataFamily = this.$commonFuction.convertJsonObject(data.data)*/
          /* this.dataFamily = data.data
           if (this.list_file_product.length > 0){
             delete this.dataFamily.list_file_product;
             delete this.dataFamily.image_list;
           }*/
          this.dataFamily =  {};

          var key_not = ['list_file_product','image_list'];
          var data_edit =data.data
          for (let key in data_edit) {
            // if (data_edit.hasOwnProperty(key)) {
            // if (data_edit.hasOwnProperty(key)) { // Check if the property is directly on the object
            // console.log(key + ': ' + person[key]);
            if ( key_not.indexOf(key) == -1 ){
              this.dataFamily[key] = data_edit[key];
              //  }
            }
          }

          /*this.dataFamily.list_file_product =this.list_file_product;
          this.dataFamily.image_list =this.list_file_product;*/
          //this.dataFamily.list_id_file_delete_product =  this.list_id_file_delete_product;
          this.dataFamilyDisplay = true;
          this.componentDataFamily++;
          break
        case 'delete':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          this.deleteId = data.data[action.key]
          console.log("this.deleteId:",this.deleteId)
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dataFamilyDisplay = true;
          this.componentDataFamily++;
          console.log("this.componentDataFamily:",this.componentDataFamily)
          /*
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }*/
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      //if (this.role.add) {
      actions.header = {name: 'add', icon: 'plus', path: `list-${this.modelName}/add`};
      //}
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        //if (that.role.edit) {
        buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-${that.modelName}/edit/`};
        //}
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        //if (that.role.delete) {
        buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
        //}
        if (that.dataModelUserFamily.actions) {
          var modelaction = that.dataModelUserFamily.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    onFileClearProduct(item,index) {
      console.log('itemitem:',item)
      var type = item?.type ?? null
      if (type =='old_edit'){
        this.list_id_file_delete_product.push(item.id);
      }
      this.list_file_product.splice(index, 1);
    },
    async onFileSelectFileProduct(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:",files)
      console.log("files.length:",files.length)
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG']
        console.log("files.length1111111:",files.length)
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:",files.length)
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:",files[i].name)
          that.obj_data.filename =files[i].name;
          this.comFilename++;
        }
        var arrTemp = [], arrFiles = [];
        for (let file of files) {
          console.log('file.sizefile.sizefile.size:',file.size)
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:",file)
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:",arrTemp)
          //this.list_file_product = [];
          this.list_file_product = this.list_file_product.concat.apply(this.list_file_product, arrTemp);
        }
      }
      this.$refs.fileInputProduct.value = null;
    },
    onFileClear(item, index) {
      console.log('itemitem:', item)
      var type = item?.type ?? null
      if (type == 'old_edit') {
        this.list_id_file_delete.push(item.id);
      }
      this.list_file.splice(index, 1);
    },
    async onFileSelectFile(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:",files)
      console.log("files.length:",files.length)
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG']
        console.log("files.length1111111:",files.length)
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:",files.length)
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:",files[i].name)
          that.obj_data.filename =files[i].name;
          this.comFilename++;
        }
        var arrTemp = [], arrFiles = [];
        for (let file of files) {
          console.log('file.sizefile.sizefile.size:',file.size)
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:",file)
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:",arrTemp)
          this.list_file = [];
          this.list_file = this.list_file.concat.apply(this.list_file, arrTemp);
          // this.showCropper = true;
          // this.imageSrc = URL.createObjectURL(arrTemp[0]);
          // this.keyCropper++;
        }
      }
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    updateMatrix(data) {
      console.log(data);
      this.dataBookingRound = [...data];
      // this.componentKey++;
    },
    async toCalendar() {
      this.$router.push(`/admin/list-booking?view=calendar&propery_id=${this.selProperty?.id}`);
    },
    async getListProperty(){
      var where_key = {
        deleted : {_eq : false},
        // booking: {id: {_is_null: true} },
      }
      var list = await this.$CoreService.getListProperty(where_key);
      this.listProperty =list.list;
      this.listPropertyAll = list.list;
    },

    async SearchProperty(search, loading){
      console.log(loading);
      if(search !== '' && search !== null){
        var where_key = {
          deleted : {_eq : false},
        };
        if (!this.$commonFuction.isEmpty(search)){
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListProperty(where_key);
        this.listProperty = list.list;
        //console.log("this.listProperty:",this.listProperty)
      }else{
        // cosnole.log("dasdasd")
        this.listProperty = this.listPropertyAll
      }
    },

    async getListDocsCate(){
      var where_key = {
        deleted : {_eq : false},
        // booking: {id: {_is_null: true} },
      }
      var list = await this.$CoreService.getListDocsCate(where_key);
      this.listDocsCate =list.list;
      this.listDocsCateAll = list.list;
    },

    async SearchDocsCate(search, loading){
      console.log(loading);
      if(search !== '' && search !== null){
        var where_key = {
          deleted : {_eq : false},
        };
        if (!this.$commonFuction.isEmpty(search)){
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListDocsCate(where_key);
        this.listDocsCate = list.list;
        //console.log("this.listProperty:",this.listProperty)
      }else{
        // cosnole.log("dasdasd")
        this.listDocsCate = this.listDocsCateAll
      }
    },

    backToList() {
      this.$emit('back');
    },
    validatePhoneNumber(phone) {
      // Biểu thức chính quy cho số điện thoại có thể có hoặc không có dấu +, không có dấu (), và -
      const phoneRegex = /^\+?[0-9\s]{7,15}$/;
      return phoneRegex.test(phone);
    }
    ,
    async validateData() {
      this.validationErrors = {};


      let name_add = document.getElementById("name");
      if (this.$commonFuction.isEmpty(this.obj_data.fullname)){
        name_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      }else {
        name_add.setCustomValidity("");
      }


      let email_add = document.getElementById("email");
      if (this.$commonFuction.isEmpty(this.obj_data.email)){
        email_add.setCustomValidity('Please enter the username');
      }else {
        email_add.setCustomValidity("");
      }

      let email_info_add = document.getElementById("email_info");
      if (this.$commonFuction.isEmpty(this.obj_data.email_info)){
        email_info_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      }else {
        // console.log("this.IsEmail(this.email)",this.IsEmail(this.email))
        if(await this.$commonFuction.IsEmail(this.obj_data.email_info)){
          var checkEmail = await this.checkEmail(this.obj_data.email_info);
          // console.log("checkEmail",checkEmail)
          if(checkEmail == true){
            email_info_add.setCustomValidity("Email already exists!");
          }else{
            email_info_add.setCustomValidity("");
          }
        }else{
          email_info_add.setCustomValidity("Email is not in correct format!");
        }
      }
      /* let phone_add = document.getElementById("phone");
       let prefix_phone = document.getElementById("prefix_phone");
       if (!this.$commonFuction.isEmpty(this.obj_data.phone) || !this.$commonFuction.isEmpty(this.obj_data.prefix_phone) ) {
         if (this.$commonFuction.isEmpty(this.obj_data.phone)){
           phone_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
         }else {
           if(this.obj_data.phone.toString().length < 8){
             phone_add.setCustomValidity("Please enter a Phone number of at least 8 characters!");
           }else{
             if(this.obj_data.phone.toString().length > 15){
               phone_add.setCustomValidity("Please enter a Phone Number with at most 15 characters!");
             }else{
               //kiểm tra
               phone_add.setCustomValidity("");
             }
           }
         }

         if (this.$commonFuction.isEmpty(this.obj_data.prefix_phone)) {
           prefix_phone.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
         } else {
           prefix_phone.setCustomValidity("");
         }
       }else {
         phone_add.setCustomValidity("");
         prefix_phone.setCustomValidity("");
       }*/
      let password_add = document.getElementById("password");
      if (this.mode == 'add') {
        if (this.$commonFuction.isEmpty(this.obj_data.password)){
          password_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        }else {
          if(this.obj_data.password.length < 6){
            password_add.setCustomValidity("Please enter a password of at least 6 characters!");
          }else{
            //kiểm tra
            password_add.setCustomValidity("");
          }
        }

        let Re_enter_password = document.getElementById("Re_enter_password");
        if (!this.$commonFuction.isEmpty(this.obj_data.password) || !this.$commonFuction.isEmpty(this.obj_data.re_password)){
          //check password khớp
          console.log('this.obj_data.password:',this.obj_data.password)
          console.log('this.obj_data.re_password:',this.obj_data.re_password)
          if (this.obj_data.password != this.obj_data.re_password){
            Re_enter_password.setCustomValidity("Passwords do not match!");
          }else {
            Re_enter_password.setCustomValidity("");
          }
        }
      }else {
        if (!this.$commonFuction.isEmpty(this.obj_data.password)){
          if(this.obj_data.password.length < 6){
            password_add.setCustomValidity("Please enter a password of at least 6 characters!");
          }else{
            //kiểm tra
            password_add.setCustomValidity("");
          }
        }else {
          password_add.setCustomValidity("");
        }
      }
      let phone = document.getElementById("phone");
      var txt_phone
      if (!this.$commonFuction.isEmpty(this.obj_data.phone)){
        if(this.obj_data.phone.length < 8){
          txt_phone = "Please enter a phone number of at least 8 characters!";
          //phone.setCustomValidity("Please enter a phone number of at least 8 characters!");
        }else{
          if (!this.validatePhoneNumber(this.obj_data.phone)){
            txt_phone =  "Invalid phone number";
          }
          //kiểm tra
          //phone.setCustomValidity("");
        }
      }
      if (!this.$commonFuction.isEmpty(txt_phone)){
        phone.setCustomValidity(txt_phone);
      }else {
        phone.setCustomValidity("");
      }
      let birthday = document.getElementById("birthday");
      if (!this.$commonFuction.isEmpty(this.obj_data.birthday)){
        //kiểm tra birthday có tương lại ko
        var current_check = moment().format("YYYYMMDD");
        var birthday_check = moment(this.obj_data.birthday).format("YYYYMMDD");
        if (parseInt(birthday_check) > parseInt(current_check)){
          birthday.setCustomValidity("The date of birth cannot be greater than the present");
        }else {
          birthday.setCustomValidity("");
        }
        /*if(this.obj_data.phone.length < 8){
          phone.setCustomValidity("Please enter a phone number of at least 8 characters!");
        }else{
          //kiểm tra
          phone.setCustomValidity("");
        }*/
      }

      /* let list_file_add = document.getElementById("list_file");
       if (this.$commonFuction.isEmpty(this.obj_data.filename)){
         list_file_add.setCustomValidity(this.$constants.MSG_TEXT.FILE_INVALID_MSG);
       }else {
         list_file_add.setCustomValidity("");
       }
 */
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }
    },
    async checkEmail(email){
      // if(this.email !== null && this.email !== ''){
      var where = {
        email: {'_eq': email},
        deleted: {'_eq': false},
        // type: {'_eq' : 'user'}
      }
      if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
      var {data} = await this.$apollo.query({
        query: DataServices.getList('users', {"fields" : "id, email"}),
        variables: {
          where_key: where
        },
        fetchPolicy: "network-only"
      })
      // console.log(data)
      return data && data[Object.keys(data)].length > 0
      //}
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      //console.log("this.from_to", this.from_to);
      //console.log("partArr", this.dataBookingRound);
      var params = this.obj_data
      //params["list_product"] = this.listDataProduct
      params["list_id_file_delete"] = this.list_id_file_delete
      params["list_file"] = this.list_file
      //params["list_user_family"] = this.listDataUserFamily
      console.log('saveData', params)
      this.$emit('save', params)
    },
  },
}
</script>

<style lang="scss">
.p-multiselect {
  width: 450px;
}
.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}
.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}
.p-multiselect-label-container{
  height: 40px;
}
.p-inputtext{
  margin:  0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}
label.p-col-fixed txt-right{
  margin-bottom: 0px!important;
}
div.p-card-field{
  padding: 0px!important;
}
.p-col-fixed {
  padding: 0px !important;
  margin:0px 0px 0px 9px !important;
}
.input_text{
  width: 760px!important;
  height: 48px!important;
}


.multiselect{
  width: 760px!important;
}


.vs__clear{
  display: none;
}
.input_width{
  width: 760px!important;
  height: 48px!important;
}
#distance{
  width: 1px!important;
  height: 48px!important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}
.manager-title{
  font-size: 24px!important;
}
.input-dif{
  margin-left: 5px!important;
  border-top: 0px;
}
.p-inputgroup-addon{
  height: 48px ;
}
.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}
label.p-col-fixed txt-right{
  margin-bottom: 0px!important;
}
div.p-card-field{
  padding: 0px!important;
}
.margin{
  margin-bottom: 12px!important;
}

.border_color{
  border: 1px solid #C8C8C8;
}
.text{
  font-weight: normal!important;
  margin-left: 15px!important;
}
.div_check{
  margin-top: 12px!important;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width{
    width: 100%!important;
  }
  .div-button{
    padding: 8px!important;
  }
  #distance{
    text-align: left!important;
    padding: 6.8px;
    width: 100%!important;
  }
  .p-inputgroup-addon{
    margin-right: 12px;
  }

}

@media screen and (max-width: 1000px) {
  .input_width{
    width: 100%!important;
  }
  .div-button{
    padding: 8px!important;
  }
  .p-inputgroup-addon{
    margin-right: 12px;
  }
  #distance{
    text-align: left!important;
    padding: 6.8px;
  }
}
/*.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}*/
.cus-text{
  margin-left: 2px;
  margin-top: 4px;
}
.style-box-phone{
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;
  .p-dropdown{
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }
  .p-focus{
    border: 0px;
    box-shadow: none ;
  }
  .p-dropdown:focus{
    border: 0px;
    box-shadow: none;
  }
  input{
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }
  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}
.style_list_image {
  display: flex;
  flex-wrap: wrap; /* Cho phép các phần tử xuống dòng */
  gap: 10px; /* Khoảng cách giữa các phần tử */
  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;
    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #D0D4D9;
      border-radius: 10px;
    }
    .button-clear{
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }

  }
}


.box-password-style{
  width: 100%;
  position: relative;
  .lg-icon-password {
    margin-top: -30px;
    display: block;
    position: absolute;
    right: 10px;
    padding: auto 5px;
    &:hover {
      cursor: pointer;
    }
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #333333;
  text-transform: uppercase;
  margin-bottom: 8px;
  margin-top: 8px;

}
.gender-options {
  display: flex;  // Sử dụng flexbox để căn chỉnh ngang
  gap: 48px;     // Khoảng cách giữa các radio button

  label {
    display: flex;
    align-items: center;  // Căn giữa theo chiều dọc
    cursor: pointer;      // Hiển thị con trỏ khi hover

    input[type="radio"] {
      width: 20px;      // Chiều rộng
      height: 20px;     // Chiều cao
      margin-right: 5px; // Khoảng cách giữa radio button và nhãn
    }
  }
}
.style_line_password{
  text-align: left;
  font: normal normal normal 16px/21px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
}




// radio button 
.p-radiobutton .p-radiobutton-box {
  position: relative;
  border: 3px solid #666666;
  background-color: #FFFFFF !important;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-left: -1px;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
  box-shadow: none !important;
  appearance: none;
}

.p-radiobutton input:focus,
.p-radiobutton input:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.p-radiobutton-box:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.p-radiobutton .p-radiobutton-box::after {
  content: '';
  width: 12px;
  height: 12px;
  background-color: #FFFFFF;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.p-radiobutton .p-radiobutton-box.p-highlight::after {
  background-color: #FFDF01;
}

.p-radiobutton .p-radiobutton-box.p-highlight {
  border-color: #666666;
  box-shadow: none !important;
}

.p-radiobutton {
  display: block;
}

.p-radiobutton-box.p-highlight.p-focus {
  box-shadow: none !important;
  outline: none !important;
  border-color: #666666 !important;
  background-color: #FFDF01;
}


.p-radiobutton {
  display: block;
  align-items: center;
  margin-right: 8px;
}

.p-radiobutton label {
  margin-left: 8px;
  vertical-align: baseline;
  position: relative;
  top: 2px;
}

.css_voucher1 {
  color: #666666;

  margin-top: 15px;

}

.p-field-checkbox,
.p-field-radiobutton {
  margin-bottom: 0px;
  display: flex;
  align-items: center;
}



.style_title_group_car_infomation {
  position: relative;
  margin-top: 10px;
  margin-bottom: 30px;
}

.style_title_group_car_infomation::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #d3d0d0;
  transform: translateX(-15px);
}

.p-multiselect {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.new-select {
  width: calc(100% - 50px);
}

.p-col-auto {
  width: 50px;
  margin-left: 5px;
}

.selected-items {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.selected-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 20px;
  margin-right: 8px;
  margin-bottom: 8px;
  font-size: 14px;
}

.remove-button {
  background: none;
  border: none;
  color: #333;
  margin-left: 8px;
  font-weight: bold;
  cursor: pointer;
  outline: none;
}

.remove-button:hover {
  color: red;
}


.p-button-outlined .p-button-label {
    color: #000000 !important;
}

</style>
